import type { FormatterMap, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
} from '@grandvisionhq/www-next/formatters'

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('book-appointment-v3'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { shipping: 'envio', overview: 'resumo', payment: 'pagamento' },
  }),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/envio', 'checkout.shipping'],
  ['/checkout/resumo', 'checkout.overview'],
  ['/checkout/pagamento', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/marcar-consulta-visual-gratuita/(.*)?', 'appointments.book'],
  ['/cancelar-marcacao-de-consulta', 'appointments.cancel'],
  ['/reagendar-marcacao-de-consulta', 'appointments.reschedule'],
]
